import {v4 as uuidv4} from "uuid";
import EnterpriseComponent from "../../EnterpriseComponent";
import EnlilAxiosRestAPI from "../../../../util/EnlilAxiosRestAPI";
import {V1DocumentTypeIDOCToArray} from "../../../../util/Payload";

class DocumentTypeEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        // status = 'DRAFT', 'PENDING_CHANGE', 'SUBMITTED', 'IN_REVIEW', 'APPROVED', 'RELEASED', 'DEPRECATED', 'OBSOLETE', 'CANCELED', 'VOIDED'

        let QBE = {
            "ShifamedMessage": {
                "-idoc": "v1.DocumentType-001",
                "-id": uuidv4(),
                "DocumentType": {
                    '_attributes': {
                        'limit': pageSize,
                        'sort': this.getFormattedSortSpecification(),
                        'offset': (page - 1) * pageSize
                    },
                    "QueryGroups": {
                        "QueryGroup": [
                            {
                                "Name": "primary",
                                "Operator": "AND",
                                "Type": "QueryGroup",
                                "Membership": {
                                    "Member": []
                                }
                            }
                        ]
                    }
                }
            }
        }
        let queryPayload = this.prepareQueryPayload();

        if (queryPayload.size > 0) {
            for (const [key, value] of queryPayload) {
                if (key.includes("_query")) continue;

                let operator = "EQUAL";
                if (queryPayload.get(key + "_query") !== undefined) {
                    operator = queryPayload.get(key + "_query")
                }
                QBE.ShifamedMessage.DocumentType.QueryGroups.QueryGroup[0].Membership.Member.push({
                    "Type": "Attribute",
                    "Name": key,
                    "Value": value,
                    "Operator": operator
                })
            }
        }

        EnlilAxiosRestAPI({
            method: "GET",
            url: "t3/v1/document_types",
            json: true,
            params: {
                "QBE": btoa(JSON.stringify(QBE))
            },
            headers: {
                "idoc-response": this.getIDOCResponse() ?? "v1.DocumentType-001",
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1DocumentTypeIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };
}

export default DocumentTypeEnterpriseComponent;